import type { LucideIcon } from "lucide-react";
import { CalendarClock, LayoutDashboard, MessageCircle, PieChart, Receipt, Wallet } from "lucide-react";

export interface Section {
  slug: string;
  path: string;
  label: string;
  title: string;
  subtitle: string;
  icon: LucideIcon;
  upcoming: string[];
}

export const SECTIONS: Section[] = [
  {
    slug: "resumen", path: "/resumen", label: "Resumen", title: "Resumen",
    subtitle: "La foto de tu mes: cuánto entra, cuánto sale y cuánto va a tu futuro.",
    icon: LayoutDashboard,
    upcoming: ["Saldo total por cuenta", "Ingresos contra gastos del mes", "Avance del presupuesto"],
  },
  {
    slug: "movimientos", path: "/movimientos", label: "Movimientos", title: "Movimientos",
    subtitle: "Registro de ingresos, gastos, transferencias y ajustes.",
    icon: Receipt,
    upcoming: ["Captura rápida de movimientos", "Filtros por cuenta y categoría", "Ajustes de saldo"],
  },
  {
    slug: "programados", path: "/programados", label: "Programados", title: "Programados",
    subtitle: "Pagos e ingresos recurrentes, incluidos los meses sin intereses.",
    icon: CalendarClock,
    upcoming: ["Recurrencia mensual, quincenal o fecha fija", "Control de cuotas", "Próximos vencimientos"],
  },
  {
    slug: "cuentas", path: "/cuentas", label: "Cuentas", title: "Cuentas",
    subtitle: "Débito, ahorro, efectivo, inversión, tarjetas de crédito y préstamos.",
    icon: Wallet,
    upcoming: ["Saldo calculado desde movimientos", "Fechas de corte y pago", "Límites de crédito"],
  },
  {
    slug: "presupuesto", path: "/presupuesto", label: "Presupuesto", title: "Presupuesto",
    subtitle: "Lo que planeas contra lo que realmente pasa cada mes.",
    icon: PieChart,
    upcoming: ["Límites por grupo", "Ajustes mensuales", "Ahorro e inversión cuentan como “Va”"],
  },
  {
    slug: "mentor", path: "/mentor", label: "Mentor", title: "Mentor",
    subtitle: "Un mentor financiero sereno que interpreta tus números, sin regaños.",
    icon: MessageCircle,
    upcoming: ["Preguntas sobre tu mes", "Contexto basado en cifras reales", "Límites de uso configurables"],
  },
];
